import axios from "axios";
import moment from "moment/moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userRole } from "@/constant";
import { changeTheme } from "@/redux/slices/theme.slice";
import { setActiveDashboard, setIsLogged, setUserDetails } from "@/redux/slices/user.slice";

const AutoLogoutTimer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user || {});
  const business = userDetails?.business?.[0] || {};

  const logout = async () => {
    try {
      await axios.get(`/user/logout`, {
        withCredentials: true,
      });
      localStorage.setItem("isLoggedIn", "no");
      dispatch(setActiveDashboard(""));
      dispatch(setIsLogged(false));
      dispatch(changeTheme(false));
      dispatch(setUserDetails({}));
      if (business?.businessUrl) {
        navigate("/" + business?.businessUrl);
      } else {
        navigate("/");
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      localStorage.setItem("isLoggedIn", "no");
      dispatch(setActiveDashboard(""));
      dispatch(setIsLogged(false));
      dispatch(changeTheme(false));
      dispatch(setUserDetails({}));
      if (business?.businessUrl) {
        navigate("/" + business?.businessUrl);
      } else {
        navigate("/");
      }
    }
  };

  const checkActiveDeviceOnSiteLoad = async () => {
    try {
      if (userDetails?._id) {
        const { data } = await axios.get(`/user/me`, {
          withCredentials: true,
        });
        const activeDeviceId = localStorage.getItem("activeDeviceId");
        if (
          data?._id &&
          data?._id === userDetails?._id &&
          userDetails?.role !== userRole.superAdmin &&
          activeDeviceId !== data?.activeDeviceId &&
          !userDetails?.multipleDeviceLogin
        ) {
          logout();
        }
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      logout();
    }
  };
  useEffect(() => {
    checkActiveDeviceOnSiteLoad();
  }, [userDetails]);

  useEffect(() => {
    const timer = setInterval(() => {
      const lastActivity = localStorage.getItem("lastActivityAt") || Date.now();
      const minDif = moment().diff(Number(lastActivity), "minute");

      const isFullScreenOn = localStorage.getItem("isFullScreenOn");
      if (isFullScreenOn !== "y" && minDif >= 30 && userDetails?.idleLogoutFot30Min) {
        logout();
      }
    }, 5000);
    localStorage.setItem("lastActivityAt", Date.now());
    const handleUserActivity = () => {
      localStorage.setItem("lastActivityAt", Date.now());
    };

    window.addEventListener("mousemove", handleUserActivity);
    window.addEventListener("mousedown", handleUserActivity);
    window.addEventListener("mouseup", handleUserActivity);
    window.addEventListener("keydown", handleUserActivity);
    window.addEventListener("keyup", handleUserActivity);
    window.addEventListener("wheel", handleUserActivity);

    return () => {
      window.removeEventListener("mousemove", handleUserActivity);
      window.removeEventListener("mousedown", handleUserActivity);
      window.removeEventListener("mouseup", handleUserActivity);
      window.removeEventListener("keydown", handleUserActivity);
      window.removeEventListener("keyup", handleUserActivity);
      window.removeEventListener("wheel", handleUserActivity);
      clearInterval(timer);
    };
  }, [dispatch, navigate]);

  return <></>;
};

export default AutoLogoutTimer;
